import React, { forwardRef, Component } from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';
const avatarVariants = cva('relative flex shrink-0 overflow-hidden rounded-full border-2 border-primary', {
  variants: {
    size: {
      sm: 'h-8 w-8',
      md: 'h-10 w-10',
      lg: 'h-16 w-16',
      xl: 'h-[120px] w-[120px]'
    }
  },
  defaultVariants: {
    size: 'md'
  }
});
export interface AvatarProps extends ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>, VariantProps<typeof avatarVariants> {}
const Avatar = forwardRef<React.ElementRef<typeof AvatarPrimitive.Root>, AvatarProps>(({
  className,
  size,
  ...props
}, ref) => <AvatarPrimitive.Root ref={ref} className={cn(avatarVariants({
  size
}), className)} {...props} data-id="element-329" />);
Avatar.displayName = AvatarPrimitive.Root.displayName;
const AvatarImage = forwardRef<React.ElementRef<typeof AvatarPrimitive.Image>, ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>>(({
  className,
  ...props
}, ref) => <AvatarPrimitive.Image ref={ref} className={cn('aspect-square h-full w-full object-cover', className)} {...props} data-id="element-330" />);
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
const AvatarFallback = forwardRef<React.ElementRef<typeof AvatarPrimitive.Fallback>, ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback>>(({
  className,
  ...props
}, ref) => <AvatarPrimitive.Fallback ref={ref} className={cn('flex h-full w-full items-center justify-center rounded-full bg-primary/10 text-primary font-bold', className)} {...props} data-id="element-331" />);
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;
export { Avatar, AvatarImage, AvatarFallback };